import { useState } from "react";

interface Option {
  value: string;
  label: string;
}

interface DropdownProps {
  label: string;
  options: Option[];
  class_name: string; // Prop para el texto del placeholder
  onSelect: (data: string, type: string) => void; // Prop para la función
  primariOptions: string;
  value?: string;
}

function Dropdown({
  options,
  class_name,
  onSelect,
  label,
  primariOptions,
  value = undefined,
}: DropdownProps) {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(event.target.value);
    onSelect(event.target.value, label);
  };

  return (
    <div>
      <label
        htmlFor="dropdown-select"
        className="block font-medium text-gray-700"
      >
        {label}
      </label>
      <select onChange={handleChange} className={class_name} value={value}>
        <option value={""}>{primariOptions}</option>
        {options.map((option) => (
          <option key={option.value} value={`${option.value}:${option.label}`}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
export default Dropdown;
